<template>
    <div>
        <galery-selector v-model="selected" selectable></galery-selector>
    </div>
</template>
<script>
export default {
    data() {
        return {
            selected: []
        };
    }
};
</script>
<style lang="scss">
</style>
